export const PAYMENT_GATEWAY = "https://bankofceylon.gateway.mastercard.com/checkout/pay/";
 // "https://test-bankofceylon.mtf.gateway.mastercard.com/checkout/pay/";
 
export const PAYMENT_GATEWAY_REDIRECT = "https://127.0.0.1:8000/api/callback/verify";
export const PAYMENT_GATEWAY_REDIRECT_FINAL = "http://localhost:3000";
